import React from 'react';

import useScript from '@common/react/hooks/useScript';

interface PodiumProps {
	token: string;
}

const Podium: React.FC<PodiumProps> = ({ token }) => {
	useScript({
		url: `https://connect.podium.com/widget.js#API_TOKEN=${token}`,
		beforeRender: (script) => {
			script.setAttribute('data-api-token', token);
		},
	});

	return <></>;
};

export default Podium;
